
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalTShape as ObiBuoySphericalTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-t-shape.js';
 
 
 

 
 export const ObiBuoySphericalTShape = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-t-shape',
   elementClass: ObiBuoySphericalTShapeElement,
   events: {
     
   }
  });
 
 